// extracted by mini-css-extract-plugin
module.exports = {"container":"YNzqBxBY","isButton":"fRU3LvRN","messageContainer":"MuZgJiOI","title":"Lqxr3Ze4","message":"b5tECRsL","iconContainer":"H0PqkIhS"};